import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMedicineTablett: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMedicineTablett"><Path d="M11.0415 4.04346C13.5031 1.58187 17.4941 1.58187 19.9557 4.04346C22.4173 6.50505 22.4173 10.4961 19.9557 12.9577L17.1628 15.7506L8.24861 6.83635L11.0415 4.04346Z" fill="currentColor"/><Path d="M6.8344 8.25057L4.04151 11.0435C1.57991 13.5051 1.57992 17.4961 4.04151 19.9577C6.5031 22.4193 10.4941 22.4193 12.9557 19.9577L15.7486 17.1648L6.8344 8.25057Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMedicineTablett;
